import { HStack, Text } from '@dotfile/frontend/shared/design-system';
import { ClientPortalChecks_CheckInterface } from '@dotfile/shared/data-access-client-portal';

import { useTranslatedCheckTitle } from '../hooks/use-translated-check-title';
import { CheckStatusBadge } from './check-status-badge';

export const CheckModalHeader = ({
  check,
}: {
  check: ClientPortalChecks_CheckInterface;
}) => {
  const checkTitle = useTranslatedCheckTitle(check);

  return (
    <HStack justifyContent="space-between">
      <Text color="black" fontSize="lg">
        {checkTitle}
      </Text>
      <CheckStatusBadge check={check} />
    </HStack>
  );
};
